import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { createPatient } from 'api/auth.api';

export const useCreatePatient = () => {
  const toast = useToast();

  return useMutation({
    mutationFn: createPatient,
    onSuccess: (res) => {
      toast({
        title: 'Patient Registered',
        description: res?.data?.message || 'Registered successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
    },

    onError: (error) => {
      toast({
        title: 'Failed to registered patient',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
